export const LOGOUT_CONSTANT = {
  WCLOGONUSERID: 'WC_LogonUserId_',
  RCLIST: 'rclist',
  WCDELETECARTCOOKIE: 'WC_DeleteCartCookie_',
  PARTSSEARCH: 'partsSearch',
  PARTSMANUAL: 'partsManual'
};
